/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as _authRouteRouteImport } from './routes/__auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordPasswordResetCodeRouteImport } from './routes/forgot-password.$passwordResetCode'
import { Route as _authTermsRouteImport } from './routes/__auth/terms'
import { Route as _authProfileRouteImport } from './routes/__auth/profile'
import { Route as _authNotificationsRouteImport } from './routes/__auth/notifications'
import { Route as _authModelerRouteImport } from './routes/__auth/modeler'
import { Route as _authLogoutRouteImport } from './routes/__auth/logout'
import { Route as _authEmailProcessConfigurationsRouteImport } from './routes/__auth/email-process-configurations'
import { Route as _authDashboardRouteImport } from './routes/__auth/dashboard'
import { Route as _authCategoriesRouteImport } from './routes/__auth/categories'
import { Route as _authBinRouteImport } from './routes/__auth/bin'
import { Route as _authTasksIndexRouteImport } from './routes/__auth/tasks/index'
import { Route as _authProfileIndexRouteImport } from './routes/__auth/profile/index'
import { Route as _authProcessesIndexRouteImport } from './routes/__auth/processes/index'
import { Route as _authProcessesV2IndexRouteImport } from './routes/__auth/processes-v2/index'
import { Route as _authDocumentsIndexRouteImport } from './routes/__auth/documents/index'
import { Route as _authDocumentsV2IndexRouteImport } from './routes/__auth/documents-v2/index'
import { Route as _authTasksAllRouteImport } from './routes/__auth/tasks/all'
import { Route as _authSignaturesSignRouteImport } from './routes/__auth/signatures/sign'
import { Route as _authSignaturesEnvelopesRouteImport } from './routes/__auth/signatures/envelopes'
import { Route as _authSignaturesCreateRouteImport } from './routes/__auth/signatures/create'
import { Route as _authProfilePasswordRouteImport } from './routes/__auth/profile/password'
import { Route as _authDocumentsNewRouteImport } from './routes/__auth/documents/new'
import { Route as _authDocumentsAnalysisRouteImport } from './routes/__auth/documents/analysis'
import { Route as _authAdminUsersRouteImport } from './routes/__auth/admin/users'
import { Route as _authAdminThemeRouteImport } from './routes/__auth/admin/theme'
import { Route as _authAdminTermsOfUseRouteImport } from './routes/__auth/admin/terms-of-use'
import { Route as _authAdminTenantsRouteImport } from './routes/__auth/admin/tenants'
import { Route as _authAdminTemplatesRouteImport } from './routes/__auth/admin/templates'
import { Route as _authAdminSearchIndexRouteImport } from './routes/__auth/admin/search-index'
import { Route as _authAdminReportsRouteImport } from './routes/__auth/admin/reports'
import { Route as _authAdminProfilesRouteImport } from './routes/__auth/admin/profiles'
import { Route as _authAdminPortalExternoUsersRouteImport } from './routes/__auth/admin/portal-externo-users'
import { Route as _authAdminOrganizationsRouteImport } from './routes/__auth/admin/organizations'
import { Route as _authAdminOrganizationDashboardRouteImport } from './routes/__auth/admin/organization-dashboard'
import { Route as _authAdminMetadataRouteImport } from './routes/__auth/admin/metadata'
import { Route as _authAdminGroupsRouteImport } from './routes/__auth/admin/groups'
import { Route as _authAdminFormsRouteImport } from './routes/__auth/admin/forms'
import { Route as _authAdminEmailTemplatesRouteImport } from './routes/__auth/admin/email-templates'
import { Route as _authAdminEmailConfigRouteImport } from './routes/__auth/admin/email-config'
import { Route as _authAdminDocumentTypesRouteImport } from './routes/__auth/admin/document-types'
import { Route as _authAdminDataListsRouteImport } from './routes/__auth/admin/data-lists'
import { Route as _authAdminClassificationRouteImport } from './routes/__auth/admin/classification'
import { Route as _authAdminAuditLogsRouteImport } from './routes/__auth/admin/audit-logs'
import { Route as _authAdminAppearanceRouteImport } from './routes/__auth/admin/appearance'
import { Route as _authAdminApiManagerRouteImport } from './routes/__auth/admin/api-manager'
import { Route as _authSignaturesIdRouteRouteImport } from './routes/__auth/signatures/$id/route'
import { Route as _authProcessesStartIndexRouteImport } from './routes/__auth/processes/start/index'
import { Route as _authAdminUsersIndexRouteImport } from './routes/__auth/admin/users/index'
import { Route as _authAdminReportsIndexRouteImport } from './routes/__auth/admin/reports/index'
import { Route as _authAdminProfilesIndexRouteImport } from './routes/__auth/admin/profiles/index'
import { Route as _authAdminGroupsIndexRouteImport } from './routes/__auth/admin/groups/index'
import { Route as _authAdminDataExportIndexRouteImport } from './routes/__auth/admin/data-export/index'
import { Route as _authTasksTaskIdExecuteRouteImport } from './routes/__auth/tasks/$taskId/execute'
import { Route as _authSignaturesIdHistoryRouteImport } from './routes/__auth/signatures/$id/history'
import { Route as _authSignaturesIdEnvelopeRouteImport } from './routes/__auth/signatures/$id/envelope'
import { Route as _authSignaturesIdDocumentsRouteImport } from './routes/__auth/signatures/$id/documents'
import { Route as _authDocumentsFoldersFolderIdRouteImport } from './routes/__auth/documents/folders/$folderId'
import { Route as _authDocumentsDoczViewRouteImport } from './routes/__auth/documents/docz/view'
import { Route as _authDocumentsPendingDocumentIdAnalyzeRouteImport } from './routes/__auth/documents/$pendingDocumentId/analyze'
import { Route as _authDocumentsDocumentIdLogRouteImport } from './routes/__auth/documents/$documentId/log'
import { Route as _authDocumentsDocumentIdEditRouteImport } from './routes/__auth/documents/$documentId/edit'
import { Route as _authAdminUsersCreateRouteImport } from './routes/__auth/admin/users/create'
import { Route as _authAdminProfilesCreateRouteImport } from './routes/__auth/admin/profiles/create'
import { Route as _authAdminGroupsCreateRouteImport } from './routes/__auth/admin/groups/create'
import { Route as _authProcessesProcessInstanceIdHistoryRouteRouteImport } from './routes/__auth/processes/$processInstanceId/history/route'
import { Route as _authProcessesProcessInstanceIdHistoryIndexRouteImport } from './routes/__auth/processes/$processInstanceId/history/index'
import { Route as _authAdminUsersUserIdIndexRouteImport } from './routes/__auth/admin/users/$userId/index'
import { Route as _authAdminReportsReportIdIndexRouteImport } from './routes/__auth/admin/reports/$reportId/index'
import { Route as _authAdminProfilesProfileIdIndexRouteImport } from './routes/__auth/admin/profiles/$profileId/index'
import { Route as _authAdminGroupsGroupIdIndexRouteImport } from './routes/__auth/admin/groups/$groupId/index'
import { Route as _authProcessesStartProcessDefinitionIdExecuteRouteImport } from './routes/__auth/processes/start/$processDefinitionId/execute'
import { Route as _authProcessesProcessInstanceIdHistoryVariablesRouteImport } from './routes/__auth/processes/$processInstanceId/history/variables'
import { Route as _authProcessesProcessInstanceIdHistoryTimelineRouteImport } from './routes/__auth/processes/$processInstanceId/history/timeline'
import { Route as _authProcessesProcessInstanceIdHistorySignatureRouteImport } from './routes/__auth/processes/$processInstanceId/history/signature'
import { Route as _authProcessesProcessInstanceIdHistoryIncidentsRouteImport } from './routes/__auth/processes/$processInstanceId/history/incidents'
import { Route as _authProcessesProcessInstanceIdHistoryDocumentsRouteImport } from './routes/__auth/processes/$processInstanceId/history/documents'
import { Route as _authProcessesProcessInstanceIdHistoryDetailsRouteImport } from './routes/__auth/processes/$processInstanceId/history/details'
import { Route as _authAdminUsersUserIdEditRouteImport } from './routes/__auth/admin/users/$userId/edit'
import { Route as _authAdminProfilesProfileIdEditRouteImport } from './routes/__auth/admin/profiles/$profileId/edit'
import { Route as _authAdminOrganizationsOrganizationKeySeiIntegrationRouteImport } from './routes/__auth/admin/organizations.$organizationKey.sei-integration'
import { Route as _authAdminGroupsGroupIdEditRouteImport } from './routes/__auth/admin/groups/$groupId/edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const _authRouteRoute = _authRouteRouteImport.update({
  id: '/__auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordPasswordResetCodeRoute =
  ForgotPasswordPasswordResetCodeRouteImport.update({
    id: '/forgot-password/$passwordResetCode',
    path: '/forgot-password/$passwordResetCode',
    getParentRoute: () => rootRouteImport,
  } as any)
const _authTermsRoute = _authTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authProfileRoute = _authProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authNotificationsRoute = _authNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authModelerRoute = _authModelerRouteImport.update({
  id: '/modeler',
  path: '/modeler',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authLogoutRoute = _authLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authEmailProcessConfigurationsRoute =
  _authEmailProcessConfigurationsRouteImport.update({
    id: '/email-process-configurations',
    path: '/email-process-configurations',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authDashboardRoute = _authDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authCategoriesRoute = _authCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authBinRoute = _authBinRouteImport.update({
  id: '/bin',
  path: '/bin',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authTasksIndexRoute = _authTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authProfileIndexRoute = _authProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authProfileRoute,
} as any)
const _authProcessesIndexRoute = _authProcessesIndexRouteImport.update({
  id: '/processes/',
  path: '/processes/',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authProcessesV2IndexRoute = _authProcessesV2IndexRouteImport.update({
  id: '/processes-v2/',
  path: '/processes-v2/',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authDocumentsIndexRoute = _authDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authDocumentsV2IndexRoute = _authDocumentsV2IndexRouteImport.update({
  id: '/documents-v2/',
  path: '/documents-v2/',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authTasksAllRoute = _authTasksAllRouteImport.update({
  id: '/tasks/all',
  path: '/tasks/all',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authSignaturesSignRoute = _authSignaturesSignRouteImport.update({
  id: '/signatures/sign',
  path: '/signatures/sign',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authSignaturesEnvelopesRoute =
  _authSignaturesEnvelopesRouteImport.update({
    id: '/signatures/envelopes',
    path: '/signatures/envelopes',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authSignaturesCreateRoute = _authSignaturesCreateRouteImport.update({
  id: '/signatures/create',
  path: '/signatures/create',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authProfilePasswordRoute = _authProfilePasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => _authProfileRoute,
} as any)
const _authDocumentsNewRoute = _authDocumentsNewRouteImport.update({
  id: '/documents/new',
  path: '/documents/new',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authDocumentsAnalysisRoute = _authDocumentsAnalysisRouteImport.update({
  id: '/documents/analysis',
  path: '/documents/analysis',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminUsersRoute = _authAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminThemeRoute = _authAdminThemeRouteImport.update({
  id: '/admin/theme',
  path: '/admin/theme',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminTermsOfUseRoute = _authAdminTermsOfUseRouteImport.update({
  id: '/admin/terms-of-use',
  path: '/admin/terms-of-use',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminTenantsRoute = _authAdminTenantsRouteImport.update({
  id: '/admin/tenants',
  path: '/admin/tenants',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminTemplatesRoute = _authAdminTemplatesRouteImport.update({
  id: '/admin/templates',
  path: '/admin/templates',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminSearchIndexRoute = _authAdminSearchIndexRouteImport.update({
  id: '/admin/search-index',
  path: '/admin/search-index',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminReportsRoute = _authAdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminProfilesRoute = _authAdminProfilesRouteImport.update({
  id: '/admin/profiles',
  path: '/admin/profiles',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminPortalExternoUsersRoute =
  _authAdminPortalExternoUsersRouteImport.update({
    id: '/admin/portal-externo-users',
    path: '/admin/portal-externo-users',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminOrganizationsRoute = _authAdminOrganizationsRouteImport.update({
  id: '/admin/organizations',
  path: '/admin/organizations',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminOrganizationDashboardRoute =
  _authAdminOrganizationDashboardRouteImport.update({
    id: '/admin/organization-dashboard',
    path: '/admin/organization-dashboard',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminMetadataRoute = _authAdminMetadataRouteImport.update({
  id: '/admin/metadata',
  path: '/admin/metadata',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminGroupsRoute = _authAdminGroupsRouteImport.update({
  id: '/admin/groups',
  path: '/admin/groups',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminFormsRoute = _authAdminFormsRouteImport.update({
  id: '/admin/forms',
  path: '/admin/forms',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminEmailTemplatesRoute =
  _authAdminEmailTemplatesRouteImport.update({
    id: '/admin/email-templates',
    path: '/admin/email-templates',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminEmailConfigRoute = _authAdminEmailConfigRouteImport.update({
  id: '/admin/email-config',
  path: '/admin/email-config',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminDocumentTypesRoute = _authAdminDocumentTypesRouteImport.update({
  id: '/admin/document-types',
  path: '/admin/document-types',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminDataListsRoute = _authAdminDataListsRouteImport.update({
  id: '/admin/data-lists',
  path: '/admin/data-lists',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminClassificationRoute =
  _authAdminClassificationRouteImport.update({
    id: '/admin/classification',
    path: '/admin/classification',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminAuditLogsRoute = _authAdminAuditLogsRouteImport.update({
  id: '/admin/audit-logs',
  path: '/admin/audit-logs',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminAppearanceRoute = _authAdminAppearanceRouteImport.update({
  id: '/admin/appearance',
  path: '/admin/appearance',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authAdminApiManagerRoute = _authAdminApiManagerRouteImport.update({
  id: '/admin/api-manager',
  path: '/admin/api-manager',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authSignaturesIdRouteRoute = _authSignaturesIdRouteRouteImport.update({
  id: '/signatures/$id',
  path: '/signatures/$id',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authProcessesStartIndexRoute =
  _authProcessesStartIndexRouteImport.update({
    id: '/processes/start/',
    path: '/processes/start/',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminUsersIndexRoute = _authAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authAdminUsersRoute,
} as any)
const _authAdminReportsIndexRoute = _authAdminReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authAdminReportsRoute,
} as any)
const _authAdminProfilesIndexRoute = _authAdminProfilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authAdminProfilesRoute,
} as any)
const _authAdminGroupsIndexRoute = _authAdminGroupsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authAdminGroupsRoute,
} as any)
const _authAdminDataExportIndexRoute =
  _authAdminDataExportIndexRouteImport.update({
    id: '/admin/data-export/',
    path: '/admin/data-export/',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authTasksTaskIdExecuteRoute = _authTasksTaskIdExecuteRouteImport.update({
  id: '/tasks/$taskId/execute',
  path: '/tasks/$taskId/execute',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authSignaturesIdHistoryRoute =
  _authSignaturesIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => _authSignaturesIdRouteRoute,
  } as any)
const _authSignaturesIdEnvelopeRoute =
  _authSignaturesIdEnvelopeRouteImport.update({
    id: '/envelope',
    path: '/envelope',
    getParentRoute: () => _authSignaturesIdRouteRoute,
  } as any)
const _authSignaturesIdDocumentsRoute =
  _authSignaturesIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => _authSignaturesIdRouteRoute,
  } as any)
const _authDocumentsFoldersFolderIdRoute =
  _authDocumentsFoldersFolderIdRouteImport.update({
    id: '/documents/folders/$folderId',
    path: '/documents/folders/$folderId',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authDocumentsDoczViewRoute = _authDocumentsDoczViewRouteImport.update({
  id: '/documents/docz/view',
  path: '/documents/docz/view',
  getParentRoute: () => _authRouteRoute,
} as any)
const _authDocumentsPendingDocumentIdAnalyzeRoute =
  _authDocumentsPendingDocumentIdAnalyzeRouteImport.update({
    id: '/documents/$pendingDocumentId/analyze',
    path: '/documents/$pendingDocumentId/analyze',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authDocumentsDocumentIdLogRoute =
  _authDocumentsDocumentIdLogRouteImport.update({
    id: '/documents/$documentId/log',
    path: '/documents/$documentId/log',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authDocumentsDocumentIdEditRoute =
  _authDocumentsDocumentIdEditRouteImport.update({
    id: '/documents/$documentId/edit',
    path: '/documents/$documentId/edit',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authAdminUsersCreateRoute = _authAdminUsersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => _authAdminUsersRoute,
} as any)
const _authAdminProfilesCreateRoute =
  _authAdminProfilesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => _authAdminProfilesRoute,
  } as any)
const _authAdminGroupsCreateRoute = _authAdminGroupsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => _authAdminGroupsRoute,
} as any)
const _authProcessesProcessInstanceIdHistoryRouteRoute =
  _authProcessesProcessInstanceIdHistoryRouteRouteImport.update({
    id: '/processes/$processInstanceId/history',
    path: '/processes/$processInstanceId/history',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryIndexRoute =
  _authProcessesProcessInstanceIdHistoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authAdminUsersUserIdIndexRoute =
  _authAdminUsersUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => _authAdminUsersRoute,
  } as any)
const _authAdminReportsReportIdIndexRoute =
  _authAdminReportsReportIdIndexRouteImport.update({
    id: '/$reportId/',
    path: '/$reportId/',
    getParentRoute: () => _authAdminReportsRoute,
  } as any)
const _authAdminProfilesProfileIdIndexRoute =
  _authAdminProfilesProfileIdIndexRouteImport.update({
    id: '/$profileId/',
    path: '/$profileId/',
    getParentRoute: () => _authAdminProfilesRoute,
  } as any)
const _authAdminGroupsGroupIdIndexRoute =
  _authAdminGroupsGroupIdIndexRouteImport.update({
    id: '/$groupId/',
    path: '/$groupId/',
    getParentRoute: () => _authAdminGroupsRoute,
  } as any)
const _authProcessesStartProcessDefinitionIdExecuteRoute =
  _authProcessesStartProcessDefinitionIdExecuteRouteImport.update({
    id: '/processes/start/$processDefinitionId/execute',
    path: '/processes/start/$processDefinitionId/execute',
    getParentRoute: () => _authRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryVariablesRoute =
  _authProcessesProcessInstanceIdHistoryVariablesRouteImport.update({
    id: '/variables',
    path: '/variables',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryTimelineRoute =
  _authProcessesProcessInstanceIdHistoryTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistorySignatureRoute =
  _authProcessesProcessInstanceIdHistorySignatureRouteImport.update({
    id: '/signature',
    path: '/signature',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryIncidentsRoute =
  _authProcessesProcessInstanceIdHistoryIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryDocumentsRoute =
  _authProcessesProcessInstanceIdHistoryDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authProcessesProcessInstanceIdHistoryDetailsRoute =
  _authProcessesProcessInstanceIdHistoryDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => _authProcessesProcessInstanceIdHistoryRouteRoute,
  } as any)
const _authAdminUsersUserIdEditRoute =
  _authAdminUsersUserIdEditRouteImport.update({
    id: '/$userId/edit',
    path: '/$userId/edit',
    getParentRoute: () => _authAdminUsersRoute,
  } as any)
const _authAdminProfilesProfileIdEditRoute =
  _authAdminProfilesProfileIdEditRouteImport.update({
    id: '/$profileId/edit',
    path: '/$profileId/edit',
    getParentRoute: () => _authAdminProfilesRoute,
  } as any)
const _authAdminOrganizationsOrganizationKeySeiIntegrationRoute =
  _authAdminOrganizationsOrganizationKeySeiIntegrationRouteImport.update({
    id: '/$organizationKey/sei-integration',
    path: '/$organizationKey/sei-integration',
    getParentRoute: () => _authAdminOrganizationsRoute,
  } as any)
const _authAdminGroupsGroupIdEditRoute =
  _authAdminGroupsGroupIdEditRouteImport.update({
    id: '/$groupId/edit',
    path: '/$groupId/edit',
    getParentRoute: () => _authAdminGroupsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/bin': typeof _authBinRoute
  '/categories': typeof _authCategoriesRoute
  '/dashboard': typeof _authDashboardRoute
  '/email-process-configurations': typeof _authEmailProcessConfigurationsRoute
  '/logout': typeof _authLogoutRoute
  '/modeler': typeof _authModelerRoute
  '/notifications': typeof _authNotificationsRoute
  '/profile': typeof _authProfileRouteWithChildren
  '/terms': typeof _authTermsRoute
  '/forgot-password/$passwordResetCode': typeof ForgotPasswordPasswordResetCodeRoute
  '/signatures/$id': typeof _authSignaturesIdRouteRouteWithChildren
  '/admin/api-manager': typeof _authAdminApiManagerRoute
  '/admin/appearance': typeof _authAdminAppearanceRoute
  '/admin/audit-logs': typeof _authAdminAuditLogsRoute
  '/admin/classification': typeof _authAdminClassificationRoute
  '/admin/data-lists': typeof _authAdminDataListsRoute
  '/admin/document-types': typeof _authAdminDocumentTypesRoute
  '/admin/email-config': typeof _authAdminEmailConfigRoute
  '/admin/email-templates': typeof _authAdminEmailTemplatesRoute
  '/admin/forms': typeof _authAdminFormsRoute
  '/admin/groups': typeof _authAdminGroupsRouteWithChildren
  '/admin/metadata': typeof _authAdminMetadataRoute
  '/admin/organization-dashboard': typeof _authAdminOrganizationDashboardRoute
  '/admin/organizations': typeof _authAdminOrganizationsRouteWithChildren
  '/admin/portal-externo-users': typeof _authAdminPortalExternoUsersRoute
  '/admin/profiles': typeof _authAdminProfilesRouteWithChildren
  '/admin/reports': typeof _authAdminReportsRouteWithChildren
  '/admin/search-index': typeof _authAdminSearchIndexRoute
  '/admin/templates': typeof _authAdminTemplatesRoute
  '/admin/tenants': typeof _authAdminTenantsRoute
  '/admin/terms-of-use': typeof _authAdminTermsOfUseRoute
  '/admin/theme': typeof _authAdminThemeRoute
  '/admin/users': typeof _authAdminUsersRouteWithChildren
  '/documents/analysis': typeof _authDocumentsAnalysisRoute
  '/documents/new': typeof _authDocumentsNewRoute
  '/profile/password': typeof _authProfilePasswordRoute
  '/signatures/create': typeof _authSignaturesCreateRoute
  '/signatures/envelopes': typeof _authSignaturesEnvelopesRoute
  '/signatures/sign': typeof _authSignaturesSignRoute
  '/tasks/all': typeof _authTasksAllRoute
  '/documents-v2/': typeof _authDocumentsV2IndexRoute
  '/documents/': typeof _authDocumentsIndexRoute
  '/processes-v2/': typeof _authProcessesV2IndexRoute
  '/processes/': typeof _authProcessesIndexRoute
  '/profile/': typeof _authProfileIndexRoute
  '/tasks/': typeof _authTasksIndexRoute
  '/processes/$processInstanceId/history': typeof _authProcessesProcessInstanceIdHistoryRouteRouteWithChildren
  '/admin/groups/create': typeof _authAdminGroupsCreateRoute
  '/admin/profiles/create': typeof _authAdminProfilesCreateRoute
  '/admin/users/create': typeof _authAdminUsersCreateRoute
  '/documents/$documentId/edit': typeof _authDocumentsDocumentIdEditRoute
  '/documents/$documentId/log': typeof _authDocumentsDocumentIdLogRoute
  '/documents/$pendingDocumentId/analyze': typeof _authDocumentsPendingDocumentIdAnalyzeRoute
  '/documents/docz/view': typeof _authDocumentsDoczViewRoute
  '/documents/folders/$folderId': typeof _authDocumentsFoldersFolderIdRoute
  '/signatures/$id/documents': typeof _authSignaturesIdDocumentsRoute
  '/signatures/$id/envelope': typeof _authSignaturesIdEnvelopeRoute
  '/signatures/$id/history': typeof _authSignaturesIdHistoryRoute
  '/tasks/$taskId/execute': typeof _authTasksTaskIdExecuteRoute
  '/admin/data-export/': typeof _authAdminDataExportIndexRoute
  '/admin/groups/': typeof _authAdminGroupsIndexRoute
  '/admin/profiles/': typeof _authAdminProfilesIndexRoute
  '/admin/reports/': typeof _authAdminReportsIndexRoute
  '/admin/users/': typeof _authAdminUsersIndexRoute
  '/processes/start/': typeof _authProcessesStartIndexRoute
  '/admin/groups/$groupId/edit': typeof _authAdminGroupsGroupIdEditRoute
  '/admin/organizations/$organizationKey/sei-integration': typeof _authAdminOrganizationsOrganizationKeySeiIntegrationRoute
  '/admin/profiles/$profileId/edit': typeof _authAdminProfilesProfileIdEditRoute
  '/admin/users/$userId/edit': typeof _authAdminUsersUserIdEditRoute
  '/processes/$processInstanceId/history/details': typeof _authProcessesProcessInstanceIdHistoryDetailsRoute
  '/processes/$processInstanceId/history/documents': typeof _authProcessesProcessInstanceIdHistoryDocumentsRoute
  '/processes/$processInstanceId/history/incidents': typeof _authProcessesProcessInstanceIdHistoryIncidentsRoute
  '/processes/$processInstanceId/history/signature': typeof _authProcessesProcessInstanceIdHistorySignatureRoute
  '/processes/$processInstanceId/history/timeline': typeof _authProcessesProcessInstanceIdHistoryTimelineRoute
  '/processes/$processInstanceId/history/variables': typeof _authProcessesProcessInstanceIdHistoryVariablesRoute
  '/processes/start/$processDefinitionId/execute': typeof _authProcessesStartProcessDefinitionIdExecuteRoute
  '/admin/groups/$groupId/': typeof _authAdminGroupsGroupIdIndexRoute
  '/admin/profiles/$profileId/': typeof _authAdminProfilesProfileIdIndexRoute
  '/admin/reports/$reportId/': typeof _authAdminReportsReportIdIndexRoute
  '/admin/users/$userId/': typeof _authAdminUsersUserIdIndexRoute
  '/processes/$processInstanceId/history/': typeof _authProcessesProcessInstanceIdHistoryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/bin': typeof _authBinRoute
  '/categories': typeof _authCategoriesRoute
  '/dashboard': typeof _authDashboardRoute
  '/email-process-configurations': typeof _authEmailProcessConfigurationsRoute
  '/logout': typeof _authLogoutRoute
  '/modeler': typeof _authModelerRoute
  '/notifications': typeof _authNotificationsRoute
  '/terms': typeof _authTermsRoute
  '/forgot-password/$passwordResetCode': typeof ForgotPasswordPasswordResetCodeRoute
  '/signatures/$id': typeof _authSignaturesIdRouteRouteWithChildren
  '/admin/api-manager': typeof _authAdminApiManagerRoute
  '/admin/appearance': typeof _authAdminAppearanceRoute
  '/admin/audit-logs': typeof _authAdminAuditLogsRoute
  '/admin/classification': typeof _authAdminClassificationRoute
  '/admin/data-lists': typeof _authAdminDataListsRoute
  '/admin/document-types': typeof _authAdminDocumentTypesRoute
  '/admin/email-config': typeof _authAdminEmailConfigRoute
  '/admin/email-templates': typeof _authAdminEmailTemplatesRoute
  '/admin/forms': typeof _authAdminFormsRoute
  '/admin/metadata': typeof _authAdminMetadataRoute
  '/admin/organization-dashboard': typeof _authAdminOrganizationDashboardRoute
  '/admin/organizations': typeof _authAdminOrganizationsRouteWithChildren
  '/admin/portal-externo-users': typeof _authAdminPortalExternoUsersRoute
  '/admin/search-index': typeof _authAdminSearchIndexRoute
  '/admin/templates': typeof _authAdminTemplatesRoute
  '/admin/tenants': typeof _authAdminTenantsRoute
  '/admin/terms-of-use': typeof _authAdminTermsOfUseRoute
  '/admin/theme': typeof _authAdminThemeRoute
  '/documents/analysis': typeof _authDocumentsAnalysisRoute
  '/documents/new': typeof _authDocumentsNewRoute
  '/profile/password': typeof _authProfilePasswordRoute
  '/signatures/create': typeof _authSignaturesCreateRoute
  '/signatures/envelopes': typeof _authSignaturesEnvelopesRoute
  '/signatures/sign': typeof _authSignaturesSignRoute
  '/tasks/all': typeof _authTasksAllRoute
  '/documents-v2': typeof _authDocumentsV2IndexRoute
  '/documents': typeof _authDocumentsIndexRoute
  '/processes-v2': typeof _authProcessesV2IndexRoute
  '/processes': typeof _authProcessesIndexRoute
  '/profile': typeof _authProfileIndexRoute
  '/tasks': typeof _authTasksIndexRoute
  '/admin/groups/create': typeof _authAdminGroupsCreateRoute
  '/admin/profiles/create': typeof _authAdminProfilesCreateRoute
  '/admin/users/create': typeof _authAdminUsersCreateRoute
  '/documents/$documentId/edit': typeof _authDocumentsDocumentIdEditRoute
  '/documents/$documentId/log': typeof _authDocumentsDocumentIdLogRoute
  '/documents/$pendingDocumentId/analyze': typeof _authDocumentsPendingDocumentIdAnalyzeRoute
  '/documents/docz/view': typeof _authDocumentsDoczViewRoute
  '/documents/folders/$folderId': typeof _authDocumentsFoldersFolderIdRoute
  '/signatures/$id/documents': typeof _authSignaturesIdDocumentsRoute
  '/signatures/$id/envelope': typeof _authSignaturesIdEnvelopeRoute
  '/signatures/$id/history': typeof _authSignaturesIdHistoryRoute
  '/tasks/$taskId/execute': typeof _authTasksTaskIdExecuteRoute
  '/admin/data-export': typeof _authAdminDataExportIndexRoute
  '/admin/groups': typeof _authAdminGroupsIndexRoute
  '/admin/profiles': typeof _authAdminProfilesIndexRoute
  '/admin/reports': typeof _authAdminReportsIndexRoute
  '/admin/users': typeof _authAdminUsersIndexRoute
  '/processes/start': typeof _authProcessesStartIndexRoute
  '/admin/groups/$groupId/edit': typeof _authAdminGroupsGroupIdEditRoute
  '/admin/organizations/$organizationKey/sei-integration': typeof _authAdminOrganizationsOrganizationKeySeiIntegrationRoute
  '/admin/profiles/$profileId/edit': typeof _authAdminProfilesProfileIdEditRoute
  '/admin/users/$userId/edit': typeof _authAdminUsersUserIdEditRoute
  '/processes/$processInstanceId/history/details': typeof _authProcessesProcessInstanceIdHistoryDetailsRoute
  '/processes/$processInstanceId/history/documents': typeof _authProcessesProcessInstanceIdHistoryDocumentsRoute
  '/processes/$processInstanceId/history/incidents': typeof _authProcessesProcessInstanceIdHistoryIncidentsRoute
  '/processes/$processInstanceId/history/signature': typeof _authProcessesProcessInstanceIdHistorySignatureRoute
  '/processes/$processInstanceId/history/timeline': typeof _authProcessesProcessInstanceIdHistoryTimelineRoute
  '/processes/$processInstanceId/history/variables': typeof _authProcessesProcessInstanceIdHistoryVariablesRoute
  '/processes/start/$processDefinitionId/execute': typeof _authProcessesStartProcessDefinitionIdExecuteRoute
  '/admin/groups/$groupId': typeof _authAdminGroupsGroupIdIndexRoute
  '/admin/profiles/$profileId': typeof _authAdminProfilesProfileIdIndexRoute
  '/admin/reports/$reportId': typeof _authAdminReportsReportIdIndexRoute
  '/admin/users/$userId': typeof _authAdminUsersUserIdIndexRoute
  '/processes/$processInstanceId/history': typeof _authProcessesProcessInstanceIdHistoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/__auth': typeof _authRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/__auth/bin': typeof _authBinRoute
  '/__auth/categories': typeof _authCategoriesRoute
  '/__auth/dashboard': typeof _authDashboardRoute
  '/__auth/email-process-configurations': typeof _authEmailProcessConfigurationsRoute
  '/__auth/logout': typeof _authLogoutRoute
  '/__auth/modeler': typeof _authModelerRoute
  '/__auth/notifications': typeof _authNotificationsRoute
  '/__auth/profile': typeof _authProfileRouteWithChildren
  '/__auth/terms': typeof _authTermsRoute
  '/forgot-password/$passwordResetCode': typeof ForgotPasswordPasswordResetCodeRoute
  '/__auth/signatures/$id': typeof _authSignaturesIdRouteRouteWithChildren
  '/__auth/admin/api-manager': typeof _authAdminApiManagerRoute
  '/__auth/admin/appearance': typeof _authAdminAppearanceRoute
  '/__auth/admin/audit-logs': typeof _authAdminAuditLogsRoute
  '/__auth/admin/classification': typeof _authAdminClassificationRoute
  '/__auth/admin/data-lists': typeof _authAdminDataListsRoute
  '/__auth/admin/document-types': typeof _authAdminDocumentTypesRoute
  '/__auth/admin/email-config': typeof _authAdminEmailConfigRoute
  '/__auth/admin/email-templates': typeof _authAdminEmailTemplatesRoute
  '/__auth/admin/forms': typeof _authAdminFormsRoute
  '/__auth/admin/groups': typeof _authAdminGroupsRouteWithChildren
  '/__auth/admin/metadata': typeof _authAdminMetadataRoute
  '/__auth/admin/organization-dashboard': typeof _authAdminOrganizationDashboardRoute
  '/__auth/admin/organizations': typeof _authAdminOrganizationsRouteWithChildren
  '/__auth/admin/portal-externo-users': typeof _authAdminPortalExternoUsersRoute
  '/__auth/admin/profiles': typeof _authAdminProfilesRouteWithChildren
  '/__auth/admin/reports': typeof _authAdminReportsRouteWithChildren
  '/__auth/admin/search-index': typeof _authAdminSearchIndexRoute
  '/__auth/admin/templates': typeof _authAdminTemplatesRoute
  '/__auth/admin/tenants': typeof _authAdminTenantsRoute
  '/__auth/admin/terms-of-use': typeof _authAdminTermsOfUseRoute
  '/__auth/admin/theme': typeof _authAdminThemeRoute
  '/__auth/admin/users': typeof _authAdminUsersRouteWithChildren
  '/__auth/documents/analysis': typeof _authDocumentsAnalysisRoute
  '/__auth/documents/new': typeof _authDocumentsNewRoute
  '/__auth/profile/password': typeof _authProfilePasswordRoute
  '/__auth/signatures/create': typeof _authSignaturesCreateRoute
  '/__auth/signatures/envelopes': typeof _authSignaturesEnvelopesRoute
  '/__auth/signatures/sign': typeof _authSignaturesSignRoute
  '/__auth/tasks/all': typeof _authTasksAllRoute
  '/__auth/documents-v2/': typeof _authDocumentsV2IndexRoute
  '/__auth/documents/': typeof _authDocumentsIndexRoute
  '/__auth/processes-v2/': typeof _authProcessesV2IndexRoute
  '/__auth/processes/': typeof _authProcessesIndexRoute
  '/__auth/profile/': typeof _authProfileIndexRoute
  '/__auth/tasks/': typeof _authTasksIndexRoute
  '/__auth/processes/$processInstanceId/history': typeof _authProcessesProcessInstanceIdHistoryRouteRouteWithChildren
  '/__auth/admin/groups/create': typeof _authAdminGroupsCreateRoute
  '/__auth/admin/profiles/create': typeof _authAdminProfilesCreateRoute
  '/__auth/admin/users/create': typeof _authAdminUsersCreateRoute
  '/__auth/documents/$documentId/edit': typeof _authDocumentsDocumentIdEditRoute
  '/__auth/documents/$documentId/log': typeof _authDocumentsDocumentIdLogRoute
  '/__auth/documents/$pendingDocumentId/analyze': typeof _authDocumentsPendingDocumentIdAnalyzeRoute
  '/__auth/documents/docz/view': typeof _authDocumentsDoczViewRoute
  '/__auth/documents/folders/$folderId': typeof _authDocumentsFoldersFolderIdRoute
  '/__auth/signatures/$id/documents': typeof _authSignaturesIdDocumentsRoute
  '/__auth/signatures/$id/envelope': typeof _authSignaturesIdEnvelopeRoute
  '/__auth/signatures/$id/history': typeof _authSignaturesIdHistoryRoute
  '/__auth/tasks/$taskId/execute': typeof _authTasksTaskIdExecuteRoute
  '/__auth/admin/data-export/': typeof _authAdminDataExportIndexRoute
  '/__auth/admin/groups/': typeof _authAdminGroupsIndexRoute
  '/__auth/admin/profiles/': typeof _authAdminProfilesIndexRoute
  '/__auth/admin/reports/': typeof _authAdminReportsIndexRoute
  '/__auth/admin/users/': typeof _authAdminUsersIndexRoute
  '/__auth/processes/start/': typeof _authProcessesStartIndexRoute
  '/__auth/admin/groups/$groupId/edit': typeof _authAdminGroupsGroupIdEditRoute
  '/__auth/admin/organizations/$organizationKey/sei-integration': typeof _authAdminOrganizationsOrganizationKeySeiIntegrationRoute
  '/__auth/admin/profiles/$profileId/edit': typeof _authAdminProfilesProfileIdEditRoute
  '/__auth/admin/users/$userId/edit': typeof _authAdminUsersUserIdEditRoute
  '/__auth/processes/$processInstanceId/history/details': typeof _authProcessesProcessInstanceIdHistoryDetailsRoute
  '/__auth/processes/$processInstanceId/history/documents': typeof _authProcessesProcessInstanceIdHistoryDocumentsRoute
  '/__auth/processes/$processInstanceId/history/incidents': typeof _authProcessesProcessInstanceIdHistoryIncidentsRoute
  '/__auth/processes/$processInstanceId/history/signature': typeof _authProcessesProcessInstanceIdHistorySignatureRoute
  '/__auth/processes/$processInstanceId/history/timeline': typeof _authProcessesProcessInstanceIdHistoryTimelineRoute
  '/__auth/processes/$processInstanceId/history/variables': typeof _authProcessesProcessInstanceIdHistoryVariablesRoute
  '/__auth/processes/start/$processDefinitionId/execute': typeof _authProcessesStartProcessDefinitionIdExecuteRoute
  '/__auth/admin/groups/$groupId/': typeof _authAdminGroupsGroupIdIndexRoute
  '/__auth/admin/profiles/$profileId/': typeof _authAdminProfilesProfileIdIndexRoute
  '/__auth/admin/reports/$reportId/': typeof _authAdminReportsReportIdIndexRoute
  '/__auth/admin/users/$userId/': typeof _authAdminUsersUserIdIndexRoute
  '/__auth/processes/$processInstanceId/history/': typeof _authProcessesProcessInstanceIdHistoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/bin'
    | '/categories'
    | '/dashboard'
    | '/email-process-configurations'
    | '/logout'
    | '/modeler'
    | '/notifications'
    | '/profile'
    | '/terms'
    | '/forgot-password/$passwordResetCode'
    | '/signatures/$id'
    | '/admin/api-manager'
    | '/admin/appearance'
    | '/admin/audit-logs'
    | '/admin/classification'
    | '/admin/data-lists'
    | '/admin/document-types'
    | '/admin/email-config'
    | '/admin/email-templates'
    | '/admin/forms'
    | '/admin/groups'
    | '/admin/metadata'
    | '/admin/organization-dashboard'
    | '/admin/organizations'
    | '/admin/portal-externo-users'
    | '/admin/profiles'
    | '/admin/reports'
    | '/admin/search-index'
    | '/admin/templates'
    | '/admin/tenants'
    | '/admin/terms-of-use'
    | '/admin/theme'
    | '/admin/users'
    | '/documents/analysis'
    | '/documents/new'
    | '/profile/password'
    | '/signatures/create'
    | '/signatures/envelopes'
    | '/signatures/sign'
    | '/tasks/all'
    | '/documents-v2/'
    | '/documents/'
    | '/processes-v2/'
    | '/processes/'
    | '/profile/'
    | '/tasks/'
    | '/processes/$processInstanceId/history'
    | '/admin/groups/create'
    | '/admin/profiles/create'
    | '/admin/users/create'
    | '/documents/$documentId/edit'
    | '/documents/$documentId/log'
    | '/documents/$pendingDocumentId/analyze'
    | '/documents/docz/view'
    | '/documents/folders/$folderId'
    | '/signatures/$id/documents'
    | '/signatures/$id/envelope'
    | '/signatures/$id/history'
    | '/tasks/$taskId/execute'
    | '/admin/data-export/'
    | '/admin/groups/'
    | '/admin/profiles/'
    | '/admin/reports/'
    | '/admin/users/'
    | '/processes/start/'
    | '/admin/groups/$groupId/edit'
    | '/admin/organizations/$organizationKey/sei-integration'
    | '/admin/profiles/$profileId/edit'
    | '/admin/users/$userId/edit'
    | '/processes/$processInstanceId/history/details'
    | '/processes/$processInstanceId/history/documents'
    | '/processes/$processInstanceId/history/incidents'
    | '/processes/$processInstanceId/history/signature'
    | '/processes/$processInstanceId/history/timeline'
    | '/processes/$processInstanceId/history/variables'
    | '/processes/start/$processDefinitionId/execute'
    | '/admin/groups/$groupId/'
    | '/admin/profiles/$profileId/'
    | '/admin/reports/$reportId/'
    | '/admin/users/$userId/'
    | '/processes/$processInstanceId/history/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/bin'
    | '/categories'
    | '/dashboard'
    | '/email-process-configurations'
    | '/logout'
    | '/modeler'
    | '/notifications'
    | '/terms'
    | '/forgot-password/$passwordResetCode'
    | '/signatures/$id'
    | '/admin/api-manager'
    | '/admin/appearance'
    | '/admin/audit-logs'
    | '/admin/classification'
    | '/admin/data-lists'
    | '/admin/document-types'
    | '/admin/email-config'
    | '/admin/email-templates'
    | '/admin/forms'
    | '/admin/metadata'
    | '/admin/organization-dashboard'
    | '/admin/organizations'
    | '/admin/portal-externo-users'
    | '/admin/search-index'
    | '/admin/templates'
    | '/admin/tenants'
    | '/admin/terms-of-use'
    | '/admin/theme'
    | '/documents/analysis'
    | '/documents/new'
    | '/profile/password'
    | '/signatures/create'
    | '/signatures/envelopes'
    | '/signatures/sign'
    | '/tasks/all'
    | '/documents-v2'
    | '/documents'
    | '/processes-v2'
    | '/processes'
    | '/profile'
    | '/tasks'
    | '/admin/groups/create'
    | '/admin/profiles/create'
    | '/admin/users/create'
    | '/documents/$documentId/edit'
    | '/documents/$documentId/log'
    | '/documents/$pendingDocumentId/analyze'
    | '/documents/docz/view'
    | '/documents/folders/$folderId'
    | '/signatures/$id/documents'
    | '/signatures/$id/envelope'
    | '/signatures/$id/history'
    | '/tasks/$taskId/execute'
    | '/admin/data-export'
    | '/admin/groups'
    | '/admin/profiles'
    | '/admin/reports'
    | '/admin/users'
    | '/processes/start'
    | '/admin/groups/$groupId/edit'
    | '/admin/organizations/$organizationKey/sei-integration'
    | '/admin/profiles/$profileId/edit'
    | '/admin/users/$userId/edit'
    | '/processes/$processInstanceId/history/details'
    | '/processes/$processInstanceId/history/documents'
    | '/processes/$processInstanceId/history/incidents'
    | '/processes/$processInstanceId/history/signature'
    | '/processes/$processInstanceId/history/timeline'
    | '/processes/$processInstanceId/history/variables'
    | '/processes/start/$processDefinitionId/execute'
    | '/admin/groups/$groupId'
    | '/admin/profiles/$profileId'
    | '/admin/reports/$reportId'
    | '/admin/users/$userId'
    | '/processes/$processInstanceId/history'
  id:
    | '__root__'
    | '/'
    | '/__auth'
    | '/login'
    | '/__auth/bin'
    | '/__auth/categories'
    | '/__auth/dashboard'
    | '/__auth/email-process-configurations'
    | '/__auth/logout'
    | '/__auth/modeler'
    | '/__auth/notifications'
    | '/__auth/profile'
    | '/__auth/terms'
    | '/forgot-password/$passwordResetCode'
    | '/__auth/signatures/$id'
    | '/__auth/admin/api-manager'
    | '/__auth/admin/appearance'
    | '/__auth/admin/audit-logs'
    | '/__auth/admin/classification'
    | '/__auth/admin/data-lists'
    | '/__auth/admin/document-types'
    | '/__auth/admin/email-config'
    | '/__auth/admin/email-templates'
    | '/__auth/admin/forms'
    | '/__auth/admin/groups'
    | '/__auth/admin/metadata'
    | '/__auth/admin/organization-dashboard'
    | '/__auth/admin/organizations'
    | '/__auth/admin/portal-externo-users'
    | '/__auth/admin/profiles'
    | '/__auth/admin/reports'
    | '/__auth/admin/search-index'
    | '/__auth/admin/templates'
    | '/__auth/admin/tenants'
    | '/__auth/admin/terms-of-use'
    | '/__auth/admin/theme'
    | '/__auth/admin/users'
    | '/__auth/documents/analysis'
    | '/__auth/documents/new'
    | '/__auth/profile/password'
    | '/__auth/signatures/create'
    | '/__auth/signatures/envelopes'
    | '/__auth/signatures/sign'
    | '/__auth/tasks/all'
    | '/__auth/documents-v2/'
    | '/__auth/documents/'
    | '/__auth/processes-v2/'
    | '/__auth/processes/'
    | '/__auth/profile/'
    | '/__auth/tasks/'
    | '/__auth/processes/$processInstanceId/history'
    | '/__auth/admin/groups/create'
    | '/__auth/admin/profiles/create'
    | '/__auth/admin/users/create'
    | '/__auth/documents/$documentId/edit'
    | '/__auth/documents/$documentId/log'
    | '/__auth/documents/$pendingDocumentId/analyze'
    | '/__auth/documents/docz/view'
    | '/__auth/documents/folders/$folderId'
    | '/__auth/signatures/$id/documents'
    | '/__auth/signatures/$id/envelope'
    | '/__auth/signatures/$id/history'
    | '/__auth/tasks/$taskId/execute'
    | '/__auth/admin/data-export/'
    | '/__auth/admin/groups/'
    | '/__auth/admin/profiles/'
    | '/__auth/admin/reports/'
    | '/__auth/admin/users/'
    | '/__auth/processes/start/'
    | '/__auth/admin/groups/$groupId/edit'
    | '/__auth/admin/organizations/$organizationKey/sei-integration'
    | '/__auth/admin/profiles/$profileId/edit'
    | '/__auth/admin/users/$userId/edit'
    | '/__auth/processes/$processInstanceId/history/details'
    | '/__auth/processes/$processInstanceId/history/documents'
    | '/__auth/processes/$processInstanceId/history/incidents'
    | '/__auth/processes/$processInstanceId/history/signature'
    | '/__auth/processes/$processInstanceId/history/timeline'
    | '/__auth/processes/$processInstanceId/history/variables'
    | '/__auth/processes/start/$processDefinitionId/execute'
    | '/__auth/admin/groups/$groupId/'
    | '/__auth/admin/profiles/$profileId/'
    | '/__auth/admin/reports/$reportId/'
    | '/__auth/admin/users/$userId/'
    | '/__auth/processes/$processInstanceId/history/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  _authRouteRoute: typeof _authRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  ForgotPasswordPasswordResetCodeRoute: typeof ForgotPasswordPasswordResetCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth': {
      id: '/__auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof _authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/$passwordResetCode': {
      id: '/forgot-password/$passwordResetCode'
      path: '/forgot-password/$passwordResetCode'
      fullPath: '/forgot-password/$passwordResetCode'
      preLoaderRoute: typeof ForgotPasswordPasswordResetCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth/terms': {
      id: '/__auth/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof _authTermsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/profile': {
      id: '/__auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof _authProfileRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/notifications': {
      id: '/__auth/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof _authNotificationsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/modeler': {
      id: '/__auth/modeler'
      path: '/modeler'
      fullPath: '/modeler'
      preLoaderRoute: typeof _authModelerRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/logout': {
      id: '/__auth/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof _authLogoutRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/email-process-configurations': {
      id: '/__auth/email-process-configurations'
      path: '/email-process-configurations'
      fullPath: '/email-process-configurations'
      preLoaderRoute: typeof _authEmailProcessConfigurationsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/dashboard': {
      id: '/__auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof _authDashboardRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/categories': {
      id: '/__auth/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof _authCategoriesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/bin': {
      id: '/__auth/bin'
      path: '/bin'
      fullPath: '/bin'
      preLoaderRoute: typeof _authBinRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/tasks/': {
      id: '/__auth/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof _authTasksIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/profile/': {
      id: '/__auth/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof _authProfileIndexRouteImport
      parentRoute: typeof _authProfileRoute
    }
    '/__auth/processes/': {
      id: '/__auth/processes/'
      path: '/processes'
      fullPath: '/processes/'
      preLoaderRoute: typeof _authProcessesIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/processes-v2/': {
      id: '/__auth/processes-v2/'
      path: '/processes-v2'
      fullPath: '/processes-v2/'
      preLoaderRoute: typeof _authProcessesV2IndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/': {
      id: '/__auth/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof _authDocumentsIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents-v2/': {
      id: '/__auth/documents-v2/'
      path: '/documents-v2'
      fullPath: '/documents-v2/'
      preLoaderRoute: typeof _authDocumentsV2IndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/tasks/all': {
      id: '/__auth/tasks/all'
      path: '/tasks/all'
      fullPath: '/tasks/all'
      preLoaderRoute: typeof _authTasksAllRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/signatures/sign': {
      id: '/__auth/signatures/sign'
      path: '/signatures/sign'
      fullPath: '/signatures/sign'
      preLoaderRoute: typeof _authSignaturesSignRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/signatures/envelopes': {
      id: '/__auth/signatures/envelopes'
      path: '/signatures/envelopes'
      fullPath: '/signatures/envelopes'
      preLoaderRoute: typeof _authSignaturesEnvelopesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/signatures/create': {
      id: '/__auth/signatures/create'
      path: '/signatures/create'
      fullPath: '/signatures/create'
      preLoaderRoute: typeof _authSignaturesCreateRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/profile/password': {
      id: '/__auth/profile/password'
      path: '/password'
      fullPath: '/profile/password'
      preLoaderRoute: typeof _authProfilePasswordRouteImport
      parentRoute: typeof _authProfileRoute
    }
    '/__auth/documents/new': {
      id: '/__auth/documents/new'
      path: '/documents/new'
      fullPath: '/documents/new'
      preLoaderRoute: typeof _authDocumentsNewRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/analysis': {
      id: '/__auth/documents/analysis'
      path: '/documents/analysis'
      fullPath: '/documents/analysis'
      preLoaderRoute: typeof _authDocumentsAnalysisRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/users': {
      id: '/__auth/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof _authAdminUsersRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/theme': {
      id: '/__auth/admin/theme'
      path: '/admin/theme'
      fullPath: '/admin/theme'
      preLoaderRoute: typeof _authAdminThemeRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/terms-of-use': {
      id: '/__auth/admin/terms-of-use'
      path: '/admin/terms-of-use'
      fullPath: '/admin/terms-of-use'
      preLoaderRoute: typeof _authAdminTermsOfUseRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/tenants': {
      id: '/__auth/admin/tenants'
      path: '/admin/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof _authAdminTenantsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/templates': {
      id: '/__auth/admin/templates'
      path: '/admin/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof _authAdminTemplatesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/search-index': {
      id: '/__auth/admin/search-index'
      path: '/admin/search-index'
      fullPath: '/admin/search-index'
      preLoaderRoute: typeof _authAdminSearchIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/reports': {
      id: '/__auth/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof _authAdminReportsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/profiles': {
      id: '/__auth/admin/profiles'
      path: '/admin/profiles'
      fullPath: '/admin/profiles'
      preLoaderRoute: typeof _authAdminProfilesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/portal-externo-users': {
      id: '/__auth/admin/portal-externo-users'
      path: '/admin/portal-externo-users'
      fullPath: '/admin/portal-externo-users'
      preLoaderRoute: typeof _authAdminPortalExternoUsersRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/organizations': {
      id: '/__auth/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof _authAdminOrganizationsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/organization-dashboard': {
      id: '/__auth/admin/organization-dashboard'
      path: '/admin/organization-dashboard'
      fullPath: '/admin/organization-dashboard'
      preLoaderRoute: typeof _authAdminOrganizationDashboardRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/metadata': {
      id: '/__auth/admin/metadata'
      path: '/admin/metadata'
      fullPath: '/admin/metadata'
      preLoaderRoute: typeof _authAdminMetadataRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/groups': {
      id: '/__auth/admin/groups'
      path: '/admin/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof _authAdminGroupsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/forms': {
      id: '/__auth/admin/forms'
      path: '/admin/forms'
      fullPath: '/admin/forms'
      preLoaderRoute: typeof _authAdminFormsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/email-templates': {
      id: '/__auth/admin/email-templates'
      path: '/admin/email-templates'
      fullPath: '/admin/email-templates'
      preLoaderRoute: typeof _authAdminEmailTemplatesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/email-config': {
      id: '/__auth/admin/email-config'
      path: '/admin/email-config'
      fullPath: '/admin/email-config'
      preLoaderRoute: typeof _authAdminEmailConfigRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/document-types': {
      id: '/__auth/admin/document-types'
      path: '/admin/document-types'
      fullPath: '/admin/document-types'
      preLoaderRoute: typeof _authAdminDocumentTypesRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/data-lists': {
      id: '/__auth/admin/data-lists'
      path: '/admin/data-lists'
      fullPath: '/admin/data-lists'
      preLoaderRoute: typeof _authAdminDataListsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/classification': {
      id: '/__auth/admin/classification'
      path: '/admin/classification'
      fullPath: '/admin/classification'
      preLoaderRoute: typeof _authAdminClassificationRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/audit-logs': {
      id: '/__auth/admin/audit-logs'
      path: '/admin/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof _authAdminAuditLogsRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/appearance': {
      id: '/__auth/admin/appearance'
      path: '/admin/appearance'
      fullPath: '/admin/appearance'
      preLoaderRoute: typeof _authAdminAppearanceRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/api-manager': {
      id: '/__auth/admin/api-manager'
      path: '/admin/api-manager'
      fullPath: '/admin/api-manager'
      preLoaderRoute: typeof _authAdminApiManagerRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/signatures/$id': {
      id: '/__auth/signatures/$id'
      path: '/signatures/$id'
      fullPath: '/signatures/$id'
      preLoaderRoute: typeof _authSignaturesIdRouteRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/processes/start/': {
      id: '/__auth/processes/start/'
      path: '/processes/start'
      fullPath: '/processes/start/'
      preLoaderRoute: typeof _authProcessesStartIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/users/': {
      id: '/__auth/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof _authAdminUsersIndexRouteImport
      parentRoute: typeof _authAdminUsersRoute
    }
    '/__auth/admin/reports/': {
      id: '/__auth/admin/reports/'
      path: '/'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof _authAdminReportsIndexRouteImport
      parentRoute: typeof _authAdminReportsRoute
    }
    '/__auth/admin/profiles/': {
      id: '/__auth/admin/profiles/'
      path: '/'
      fullPath: '/admin/profiles/'
      preLoaderRoute: typeof _authAdminProfilesIndexRouteImport
      parentRoute: typeof _authAdminProfilesRoute
    }
    '/__auth/admin/groups/': {
      id: '/__auth/admin/groups/'
      path: '/'
      fullPath: '/admin/groups/'
      preLoaderRoute: typeof _authAdminGroupsIndexRouteImport
      parentRoute: typeof _authAdminGroupsRoute
    }
    '/__auth/admin/data-export/': {
      id: '/__auth/admin/data-export/'
      path: '/admin/data-export'
      fullPath: '/admin/data-export/'
      preLoaderRoute: typeof _authAdminDataExportIndexRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/tasks/$taskId/execute': {
      id: '/__auth/tasks/$taskId/execute'
      path: '/tasks/$taskId/execute'
      fullPath: '/tasks/$taskId/execute'
      preLoaderRoute: typeof _authTasksTaskIdExecuteRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/signatures/$id/history': {
      id: '/__auth/signatures/$id/history'
      path: '/history'
      fullPath: '/signatures/$id/history'
      preLoaderRoute: typeof _authSignaturesIdHistoryRouteImport
      parentRoute: typeof _authSignaturesIdRouteRoute
    }
    '/__auth/signatures/$id/envelope': {
      id: '/__auth/signatures/$id/envelope'
      path: '/envelope'
      fullPath: '/signatures/$id/envelope'
      preLoaderRoute: typeof _authSignaturesIdEnvelopeRouteImport
      parentRoute: typeof _authSignaturesIdRouteRoute
    }
    '/__auth/signatures/$id/documents': {
      id: '/__auth/signatures/$id/documents'
      path: '/documents'
      fullPath: '/signatures/$id/documents'
      preLoaderRoute: typeof _authSignaturesIdDocumentsRouteImport
      parentRoute: typeof _authSignaturesIdRouteRoute
    }
    '/__auth/documents/folders/$folderId': {
      id: '/__auth/documents/folders/$folderId'
      path: '/documents/folders/$folderId'
      fullPath: '/documents/folders/$folderId'
      preLoaderRoute: typeof _authDocumentsFoldersFolderIdRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/docz/view': {
      id: '/__auth/documents/docz/view'
      path: '/documents/docz/view'
      fullPath: '/documents/docz/view'
      preLoaderRoute: typeof _authDocumentsDoczViewRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/$pendingDocumentId/analyze': {
      id: '/__auth/documents/$pendingDocumentId/analyze'
      path: '/documents/$pendingDocumentId/analyze'
      fullPath: '/documents/$pendingDocumentId/analyze'
      preLoaderRoute: typeof _authDocumentsPendingDocumentIdAnalyzeRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/$documentId/log': {
      id: '/__auth/documents/$documentId/log'
      path: '/documents/$documentId/log'
      fullPath: '/documents/$documentId/log'
      preLoaderRoute: typeof _authDocumentsDocumentIdLogRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/documents/$documentId/edit': {
      id: '/__auth/documents/$documentId/edit'
      path: '/documents/$documentId/edit'
      fullPath: '/documents/$documentId/edit'
      preLoaderRoute: typeof _authDocumentsDocumentIdEditRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/admin/users/create': {
      id: '/__auth/admin/users/create'
      path: '/create'
      fullPath: '/admin/users/create'
      preLoaderRoute: typeof _authAdminUsersCreateRouteImport
      parentRoute: typeof _authAdminUsersRoute
    }
    '/__auth/admin/profiles/create': {
      id: '/__auth/admin/profiles/create'
      path: '/create'
      fullPath: '/admin/profiles/create'
      preLoaderRoute: typeof _authAdminProfilesCreateRouteImport
      parentRoute: typeof _authAdminProfilesRoute
    }
    '/__auth/admin/groups/create': {
      id: '/__auth/admin/groups/create'
      path: '/create'
      fullPath: '/admin/groups/create'
      preLoaderRoute: typeof _authAdminGroupsCreateRouteImport
      parentRoute: typeof _authAdminGroupsRoute
    }
    '/__auth/processes/$processInstanceId/history': {
      id: '/__auth/processes/$processInstanceId/history'
      path: '/processes/$processInstanceId/history'
      fullPath: '/processes/$processInstanceId/history'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/': {
      id: '/__auth/processes/$processInstanceId/history/'
      path: '/'
      fullPath: '/processes/$processInstanceId/history/'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryIndexRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/admin/users/$userId/': {
      id: '/__auth/admin/users/$userId/'
      path: '/$userId'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof _authAdminUsersUserIdIndexRouteImport
      parentRoute: typeof _authAdminUsersRoute
    }
    '/__auth/admin/reports/$reportId/': {
      id: '/__auth/admin/reports/$reportId/'
      path: '/$reportId'
      fullPath: '/admin/reports/$reportId/'
      preLoaderRoute: typeof _authAdminReportsReportIdIndexRouteImport
      parentRoute: typeof _authAdminReportsRoute
    }
    '/__auth/admin/profiles/$profileId/': {
      id: '/__auth/admin/profiles/$profileId/'
      path: '/$profileId'
      fullPath: '/admin/profiles/$profileId/'
      preLoaderRoute: typeof _authAdminProfilesProfileIdIndexRouteImport
      parentRoute: typeof _authAdminProfilesRoute
    }
    '/__auth/admin/groups/$groupId/': {
      id: '/__auth/admin/groups/$groupId/'
      path: '/$groupId'
      fullPath: '/admin/groups/$groupId/'
      preLoaderRoute: typeof _authAdminGroupsGroupIdIndexRouteImport
      parentRoute: typeof _authAdminGroupsRoute
    }
    '/__auth/processes/start/$processDefinitionId/execute': {
      id: '/__auth/processes/start/$processDefinitionId/execute'
      path: '/processes/start/$processDefinitionId/execute'
      fullPath: '/processes/start/$processDefinitionId/execute'
      preLoaderRoute: typeof _authProcessesStartProcessDefinitionIdExecuteRouteImport
      parentRoute: typeof _authRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/variables': {
      id: '/__auth/processes/$processInstanceId/history/variables'
      path: '/variables'
      fullPath: '/processes/$processInstanceId/history/variables'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryVariablesRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/timeline': {
      id: '/__auth/processes/$processInstanceId/history/timeline'
      path: '/timeline'
      fullPath: '/processes/$processInstanceId/history/timeline'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryTimelineRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/signature': {
      id: '/__auth/processes/$processInstanceId/history/signature'
      path: '/signature'
      fullPath: '/processes/$processInstanceId/history/signature'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistorySignatureRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/incidents': {
      id: '/__auth/processes/$processInstanceId/history/incidents'
      path: '/incidents'
      fullPath: '/processes/$processInstanceId/history/incidents'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryIncidentsRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/documents': {
      id: '/__auth/processes/$processInstanceId/history/documents'
      path: '/documents'
      fullPath: '/processes/$processInstanceId/history/documents'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryDocumentsRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/processes/$processInstanceId/history/details': {
      id: '/__auth/processes/$processInstanceId/history/details'
      path: '/details'
      fullPath: '/processes/$processInstanceId/history/details'
      preLoaderRoute: typeof _authProcessesProcessInstanceIdHistoryDetailsRouteImport
      parentRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRoute
    }
    '/__auth/admin/users/$userId/edit': {
      id: '/__auth/admin/users/$userId/edit'
      path: '/$userId/edit'
      fullPath: '/admin/users/$userId/edit'
      preLoaderRoute: typeof _authAdminUsersUserIdEditRouteImport
      parentRoute: typeof _authAdminUsersRoute
    }
    '/__auth/admin/profiles/$profileId/edit': {
      id: '/__auth/admin/profiles/$profileId/edit'
      path: '/$profileId/edit'
      fullPath: '/admin/profiles/$profileId/edit'
      preLoaderRoute: typeof _authAdminProfilesProfileIdEditRouteImport
      parentRoute: typeof _authAdminProfilesRoute
    }
    '/__auth/admin/organizations/$organizationKey/sei-integration': {
      id: '/__auth/admin/organizations/$organizationKey/sei-integration'
      path: '/$organizationKey/sei-integration'
      fullPath: '/admin/organizations/$organizationKey/sei-integration'
      preLoaderRoute: typeof _authAdminOrganizationsOrganizationKeySeiIntegrationRouteImport
      parentRoute: typeof _authAdminOrganizationsRoute
    }
    '/__auth/admin/groups/$groupId/edit': {
      id: '/__auth/admin/groups/$groupId/edit'
      path: '/$groupId/edit'
      fullPath: '/admin/groups/$groupId/edit'
      preLoaderRoute: typeof _authAdminGroupsGroupIdEditRouteImport
      parentRoute: typeof _authAdminGroupsRoute
    }
  }
}

interface _authProfileRouteChildren {
  _authProfilePasswordRoute: typeof _authProfilePasswordRoute
  _authProfileIndexRoute: typeof _authProfileIndexRoute
}

const _authProfileRouteChildren: _authProfileRouteChildren = {
  _authProfilePasswordRoute: _authProfilePasswordRoute,
  _authProfileIndexRoute: _authProfileIndexRoute,
}

const _authProfileRouteWithChildren = _authProfileRoute._addFileChildren(
  _authProfileRouteChildren,
)

interface _authSignaturesIdRouteRouteChildren {
  _authSignaturesIdDocumentsRoute: typeof _authSignaturesIdDocumentsRoute
  _authSignaturesIdEnvelopeRoute: typeof _authSignaturesIdEnvelopeRoute
  _authSignaturesIdHistoryRoute: typeof _authSignaturesIdHistoryRoute
}

const _authSignaturesIdRouteRouteChildren: _authSignaturesIdRouteRouteChildren =
  {
    _authSignaturesIdDocumentsRoute: _authSignaturesIdDocumentsRoute,
    _authSignaturesIdEnvelopeRoute: _authSignaturesIdEnvelopeRoute,
    _authSignaturesIdHistoryRoute: _authSignaturesIdHistoryRoute,
  }

const _authSignaturesIdRouteRouteWithChildren =
  _authSignaturesIdRouteRoute._addFileChildren(
    _authSignaturesIdRouteRouteChildren,
  )

interface _authAdminGroupsRouteChildren {
  _authAdminGroupsCreateRoute: typeof _authAdminGroupsCreateRoute
  _authAdminGroupsIndexRoute: typeof _authAdminGroupsIndexRoute
  _authAdminGroupsGroupIdEditRoute: typeof _authAdminGroupsGroupIdEditRoute
  _authAdminGroupsGroupIdIndexRoute: typeof _authAdminGroupsGroupIdIndexRoute
}

const _authAdminGroupsRouteChildren: _authAdminGroupsRouteChildren = {
  _authAdminGroupsCreateRoute: _authAdminGroupsCreateRoute,
  _authAdminGroupsIndexRoute: _authAdminGroupsIndexRoute,
  _authAdminGroupsGroupIdEditRoute: _authAdminGroupsGroupIdEditRoute,
  _authAdminGroupsGroupIdIndexRoute: _authAdminGroupsGroupIdIndexRoute,
}

const _authAdminGroupsRouteWithChildren =
  _authAdminGroupsRoute._addFileChildren(_authAdminGroupsRouteChildren)

interface _authAdminOrganizationsRouteChildren {
  _authAdminOrganizationsOrganizationKeySeiIntegrationRoute: typeof _authAdminOrganizationsOrganizationKeySeiIntegrationRoute
}

const _authAdminOrganizationsRouteChildren: _authAdminOrganizationsRouteChildren =
  {
    _authAdminOrganizationsOrganizationKeySeiIntegrationRoute:
      _authAdminOrganizationsOrganizationKeySeiIntegrationRoute,
  }

const _authAdminOrganizationsRouteWithChildren =
  _authAdminOrganizationsRoute._addFileChildren(
    _authAdminOrganizationsRouteChildren,
  )

interface _authAdminProfilesRouteChildren {
  _authAdminProfilesCreateRoute: typeof _authAdminProfilesCreateRoute
  _authAdminProfilesIndexRoute: typeof _authAdminProfilesIndexRoute
  _authAdminProfilesProfileIdEditRoute: typeof _authAdminProfilesProfileIdEditRoute
  _authAdminProfilesProfileIdIndexRoute: typeof _authAdminProfilesProfileIdIndexRoute
}

const _authAdminProfilesRouteChildren: _authAdminProfilesRouteChildren = {
  _authAdminProfilesCreateRoute: _authAdminProfilesCreateRoute,
  _authAdminProfilesIndexRoute: _authAdminProfilesIndexRoute,
  _authAdminProfilesProfileIdEditRoute: _authAdminProfilesProfileIdEditRoute,
  _authAdminProfilesProfileIdIndexRoute: _authAdminProfilesProfileIdIndexRoute,
}

const _authAdminProfilesRouteWithChildren =
  _authAdminProfilesRoute._addFileChildren(_authAdminProfilesRouteChildren)

interface _authAdminReportsRouteChildren {
  _authAdminReportsIndexRoute: typeof _authAdminReportsIndexRoute
  _authAdminReportsReportIdIndexRoute: typeof _authAdminReportsReportIdIndexRoute
}

const _authAdminReportsRouteChildren: _authAdminReportsRouteChildren = {
  _authAdminReportsIndexRoute: _authAdminReportsIndexRoute,
  _authAdminReportsReportIdIndexRoute: _authAdminReportsReportIdIndexRoute,
}

const _authAdminReportsRouteWithChildren =
  _authAdminReportsRoute._addFileChildren(_authAdminReportsRouteChildren)

interface _authAdminUsersRouteChildren {
  _authAdminUsersCreateRoute: typeof _authAdminUsersCreateRoute
  _authAdminUsersIndexRoute: typeof _authAdminUsersIndexRoute
  _authAdminUsersUserIdEditRoute: typeof _authAdminUsersUserIdEditRoute
  _authAdminUsersUserIdIndexRoute: typeof _authAdminUsersUserIdIndexRoute
}

const _authAdminUsersRouteChildren: _authAdminUsersRouteChildren = {
  _authAdminUsersCreateRoute: _authAdminUsersCreateRoute,
  _authAdminUsersIndexRoute: _authAdminUsersIndexRoute,
  _authAdminUsersUserIdEditRoute: _authAdminUsersUserIdEditRoute,
  _authAdminUsersUserIdIndexRoute: _authAdminUsersUserIdIndexRoute,
}

const _authAdminUsersRouteWithChildren = _authAdminUsersRoute._addFileChildren(
  _authAdminUsersRouteChildren,
)

interface _authProcessesProcessInstanceIdHistoryRouteRouteChildren {
  _authProcessesProcessInstanceIdHistoryDetailsRoute: typeof _authProcessesProcessInstanceIdHistoryDetailsRoute
  _authProcessesProcessInstanceIdHistoryDocumentsRoute: typeof _authProcessesProcessInstanceIdHistoryDocumentsRoute
  _authProcessesProcessInstanceIdHistoryIncidentsRoute: typeof _authProcessesProcessInstanceIdHistoryIncidentsRoute
  _authProcessesProcessInstanceIdHistorySignatureRoute: typeof _authProcessesProcessInstanceIdHistorySignatureRoute
  _authProcessesProcessInstanceIdHistoryTimelineRoute: typeof _authProcessesProcessInstanceIdHistoryTimelineRoute
  _authProcessesProcessInstanceIdHistoryVariablesRoute: typeof _authProcessesProcessInstanceIdHistoryVariablesRoute
  _authProcessesProcessInstanceIdHistoryIndexRoute: typeof _authProcessesProcessInstanceIdHistoryIndexRoute
}

const _authProcessesProcessInstanceIdHistoryRouteRouteChildren: _authProcessesProcessInstanceIdHistoryRouteRouteChildren =
  {
    _authProcessesProcessInstanceIdHistoryDetailsRoute:
      _authProcessesProcessInstanceIdHistoryDetailsRoute,
    _authProcessesProcessInstanceIdHistoryDocumentsRoute:
      _authProcessesProcessInstanceIdHistoryDocumentsRoute,
    _authProcessesProcessInstanceIdHistoryIncidentsRoute:
      _authProcessesProcessInstanceIdHistoryIncidentsRoute,
    _authProcessesProcessInstanceIdHistorySignatureRoute:
      _authProcessesProcessInstanceIdHistorySignatureRoute,
    _authProcessesProcessInstanceIdHistoryTimelineRoute:
      _authProcessesProcessInstanceIdHistoryTimelineRoute,
    _authProcessesProcessInstanceIdHistoryVariablesRoute:
      _authProcessesProcessInstanceIdHistoryVariablesRoute,
    _authProcessesProcessInstanceIdHistoryIndexRoute:
      _authProcessesProcessInstanceIdHistoryIndexRoute,
  }

const _authProcessesProcessInstanceIdHistoryRouteRouteWithChildren =
  _authProcessesProcessInstanceIdHistoryRouteRoute._addFileChildren(
    _authProcessesProcessInstanceIdHistoryRouteRouteChildren,
  )

interface _authRouteRouteChildren {
  _authBinRoute: typeof _authBinRoute
  _authCategoriesRoute: typeof _authCategoriesRoute
  _authDashboardRoute: typeof _authDashboardRoute
  _authEmailProcessConfigurationsRoute: typeof _authEmailProcessConfigurationsRoute
  _authLogoutRoute: typeof _authLogoutRoute
  _authModelerRoute: typeof _authModelerRoute
  _authNotificationsRoute: typeof _authNotificationsRoute
  _authProfileRoute: typeof _authProfileRouteWithChildren
  _authTermsRoute: typeof _authTermsRoute
  _authSignaturesIdRouteRoute: typeof _authSignaturesIdRouteRouteWithChildren
  _authAdminApiManagerRoute: typeof _authAdminApiManagerRoute
  _authAdminAppearanceRoute: typeof _authAdminAppearanceRoute
  _authAdminAuditLogsRoute: typeof _authAdminAuditLogsRoute
  _authAdminClassificationRoute: typeof _authAdminClassificationRoute
  _authAdminDataListsRoute: typeof _authAdminDataListsRoute
  _authAdminDocumentTypesRoute: typeof _authAdminDocumentTypesRoute
  _authAdminEmailConfigRoute: typeof _authAdminEmailConfigRoute
  _authAdminEmailTemplatesRoute: typeof _authAdminEmailTemplatesRoute
  _authAdminFormsRoute: typeof _authAdminFormsRoute
  _authAdminGroupsRoute: typeof _authAdminGroupsRouteWithChildren
  _authAdminMetadataRoute: typeof _authAdminMetadataRoute
  _authAdminOrganizationDashboardRoute: typeof _authAdminOrganizationDashboardRoute
  _authAdminOrganizationsRoute: typeof _authAdminOrganizationsRouteWithChildren
  _authAdminPortalExternoUsersRoute: typeof _authAdminPortalExternoUsersRoute
  _authAdminProfilesRoute: typeof _authAdminProfilesRouteWithChildren
  _authAdminReportsRoute: typeof _authAdminReportsRouteWithChildren
  _authAdminSearchIndexRoute: typeof _authAdminSearchIndexRoute
  _authAdminTemplatesRoute: typeof _authAdminTemplatesRoute
  _authAdminTenantsRoute: typeof _authAdminTenantsRoute
  _authAdminTermsOfUseRoute: typeof _authAdminTermsOfUseRoute
  _authAdminThemeRoute: typeof _authAdminThemeRoute
  _authAdminUsersRoute: typeof _authAdminUsersRouteWithChildren
  _authDocumentsAnalysisRoute: typeof _authDocumentsAnalysisRoute
  _authDocumentsNewRoute: typeof _authDocumentsNewRoute
  _authSignaturesCreateRoute: typeof _authSignaturesCreateRoute
  _authSignaturesEnvelopesRoute: typeof _authSignaturesEnvelopesRoute
  _authSignaturesSignRoute: typeof _authSignaturesSignRoute
  _authTasksAllRoute: typeof _authTasksAllRoute
  _authDocumentsV2IndexRoute: typeof _authDocumentsV2IndexRoute
  _authDocumentsIndexRoute: typeof _authDocumentsIndexRoute
  _authProcessesV2IndexRoute: typeof _authProcessesV2IndexRoute
  _authProcessesIndexRoute: typeof _authProcessesIndexRoute
  _authTasksIndexRoute: typeof _authTasksIndexRoute
  _authProcessesProcessInstanceIdHistoryRouteRoute: typeof _authProcessesProcessInstanceIdHistoryRouteRouteWithChildren
  _authDocumentsDocumentIdEditRoute: typeof _authDocumentsDocumentIdEditRoute
  _authDocumentsDocumentIdLogRoute: typeof _authDocumentsDocumentIdLogRoute
  _authDocumentsPendingDocumentIdAnalyzeRoute: typeof _authDocumentsPendingDocumentIdAnalyzeRoute
  _authDocumentsDoczViewRoute: typeof _authDocumentsDoczViewRoute
  _authDocumentsFoldersFolderIdRoute: typeof _authDocumentsFoldersFolderIdRoute
  _authTasksTaskIdExecuteRoute: typeof _authTasksTaskIdExecuteRoute
  _authAdminDataExportIndexRoute: typeof _authAdminDataExportIndexRoute
  _authProcessesStartIndexRoute: typeof _authProcessesStartIndexRoute
  _authProcessesStartProcessDefinitionIdExecuteRoute: typeof _authProcessesStartProcessDefinitionIdExecuteRoute
}

const _authRouteRouteChildren: _authRouteRouteChildren = {
  _authBinRoute: _authBinRoute,
  _authCategoriesRoute: _authCategoriesRoute,
  _authDashboardRoute: _authDashboardRoute,
  _authEmailProcessConfigurationsRoute: _authEmailProcessConfigurationsRoute,
  _authLogoutRoute: _authLogoutRoute,
  _authModelerRoute: _authModelerRoute,
  _authNotificationsRoute: _authNotificationsRoute,
  _authProfileRoute: _authProfileRouteWithChildren,
  _authTermsRoute: _authTermsRoute,
  _authSignaturesIdRouteRoute: _authSignaturesIdRouteRouteWithChildren,
  _authAdminApiManagerRoute: _authAdminApiManagerRoute,
  _authAdminAppearanceRoute: _authAdminAppearanceRoute,
  _authAdminAuditLogsRoute: _authAdminAuditLogsRoute,
  _authAdminClassificationRoute: _authAdminClassificationRoute,
  _authAdminDataListsRoute: _authAdminDataListsRoute,
  _authAdminDocumentTypesRoute: _authAdminDocumentTypesRoute,
  _authAdminEmailConfigRoute: _authAdminEmailConfigRoute,
  _authAdminEmailTemplatesRoute: _authAdminEmailTemplatesRoute,
  _authAdminFormsRoute: _authAdminFormsRoute,
  _authAdminGroupsRoute: _authAdminGroupsRouteWithChildren,
  _authAdminMetadataRoute: _authAdminMetadataRoute,
  _authAdminOrganizationDashboardRoute: _authAdminOrganizationDashboardRoute,
  _authAdminOrganizationsRoute: _authAdminOrganizationsRouteWithChildren,
  _authAdminPortalExternoUsersRoute: _authAdminPortalExternoUsersRoute,
  _authAdminProfilesRoute: _authAdminProfilesRouteWithChildren,
  _authAdminReportsRoute: _authAdminReportsRouteWithChildren,
  _authAdminSearchIndexRoute: _authAdminSearchIndexRoute,
  _authAdminTemplatesRoute: _authAdminTemplatesRoute,
  _authAdminTenantsRoute: _authAdminTenantsRoute,
  _authAdminTermsOfUseRoute: _authAdminTermsOfUseRoute,
  _authAdminThemeRoute: _authAdminThemeRoute,
  _authAdminUsersRoute: _authAdminUsersRouteWithChildren,
  _authDocumentsAnalysisRoute: _authDocumentsAnalysisRoute,
  _authDocumentsNewRoute: _authDocumentsNewRoute,
  _authSignaturesCreateRoute: _authSignaturesCreateRoute,
  _authSignaturesEnvelopesRoute: _authSignaturesEnvelopesRoute,
  _authSignaturesSignRoute: _authSignaturesSignRoute,
  _authTasksAllRoute: _authTasksAllRoute,
  _authDocumentsV2IndexRoute: _authDocumentsV2IndexRoute,
  _authDocumentsIndexRoute: _authDocumentsIndexRoute,
  _authProcessesV2IndexRoute: _authProcessesV2IndexRoute,
  _authProcessesIndexRoute: _authProcessesIndexRoute,
  _authTasksIndexRoute: _authTasksIndexRoute,
  _authProcessesProcessInstanceIdHistoryRouteRoute:
    _authProcessesProcessInstanceIdHistoryRouteRouteWithChildren,
  _authDocumentsDocumentIdEditRoute: _authDocumentsDocumentIdEditRoute,
  _authDocumentsDocumentIdLogRoute: _authDocumentsDocumentIdLogRoute,
  _authDocumentsPendingDocumentIdAnalyzeRoute:
    _authDocumentsPendingDocumentIdAnalyzeRoute,
  _authDocumentsDoczViewRoute: _authDocumentsDoczViewRoute,
  _authDocumentsFoldersFolderIdRoute: _authDocumentsFoldersFolderIdRoute,
  _authTasksTaskIdExecuteRoute: _authTasksTaskIdExecuteRoute,
  _authAdminDataExportIndexRoute: _authAdminDataExportIndexRoute,
  _authProcessesStartIndexRoute: _authProcessesStartIndexRoute,
  _authProcessesStartProcessDefinitionIdExecuteRoute:
    _authProcessesStartProcessDefinitionIdExecuteRoute,
}

const _authRouteRouteWithChildren = _authRouteRoute._addFileChildren(
  _authRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  _authRouteRoute: _authRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  ForgotPasswordPasswordResetCodeRoute: ForgotPasswordPasswordResetCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
